import { render, staticRenderFns } from "./ChainList.vue?vue&type=template&id=069b74e7&scoped=true&"
import script from "./ChainList.vue?vue&type=script&lang=js&"
export * from "./ChainList.vue?vue&type=script&lang=js&"
import style0 from "./ChainList.vue?vue&type=style&index=0&id=069b74e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b74e7",
  null
  
)

export default component.exports